import { Liability } from 'app/models/entities/accounting/liability';
import { FixedAsset } from 'app/models/entities/accounting/fixed-asset';
import { Equity } from 'app/models/entities/accounting/equity';
import { Category } from 'app/models/entities/accounting/category';

export class TransactionRuleAction
{
    id: number;
    transactionType: string;
    accountType: string;
    accountId: number;

    memo: string;

    account: Category | Equity | FixedAsset | Liability;

    constructor(req: any) {
        this.id = req.id;
        this.transactionType = req.transactionType;
        this.accountType = req.accountType;
        this.accountId = req.accountId;
        this.memo = req.memo;
        this.account = this.createAccount(req.account, req.accountType);
    }

    private createAccount(accountData: any, accountType: string): Category | Equity | FixedAsset | Liability | null {
        if (!accountData) { return null; }
        if (accountType.includes('Category')) { return new Category(accountData); }
        if (accountType.includes('Equity')) { return new Equity(accountData); }
        if (accountType.includes('FixedAsset')) { return new FixedAsset(accountData); }
        if (accountType.includes('Liability')) { return new Liability(accountData); }
        return null;
    }
}
